import React from 'react';
import PropTypes from 'prop-types';

import SrModalV2 from 'client/components/SrModalV2/SrModalV2';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrLinkUrlButton from 'client/components/SrLinkUrlButton';

const SrPartnerShareListingModal = ({ onClose, appUrl, listingId, location }) => (
  <SrModalV2
    centerContent
    closeOnBackgroundClick
    showCloseButton
    onClose={onClose}
    padding='0 10px'
  >
    <SrBox
      borderRadius='14px'
      backgroundColor='white'
      padding='18px 20px 20px 20px'
    >
      <SrText
        font='greycliff'
        color='blueGreycliff'
        fontSize='30px'
        lineHeight='36px'
        weight='800'
        display='block'
      >
        Copy &amp; paste link to share page.
      </SrText>
      <SrBox marginTop='12px'>
        <SrText
          font='greycliff'
          color='blueGreycliff'
          fontSize='16px'
          lineHeight='21px'
          weight='800'
          opacity='0.5'
        >
          Send to anyone who wants to see this property activity
        </SrText>
      </SrBox>
      <SrBox marginTop='20px'>
        <SrBox marginBottom='8px'>
          <SrText
            font='greycliff'
            fontSize='21px'
            weight='800'
          >
            For Owners Only
          </SrText>
        </SrBox>
        <SrLinkUrlButton
          className='blueTheme'
          href={[
            appUrl,
            location.pathname,
            '?',
            [
              'utm_source=sunroom',
              'utm_medium=textlink',
              'utm_campaign=share-this-page',
              'utm_content=copy-link',
            ].join('&'),
          ].join('')}
        />
      </SrBox>
      <SrBox marginTop='20px'>
        <SrBox marginBottom='8px'>
          <SrText
            font='greycliff'
            fontSize='21px'
            weight='800'
          >
            Renter Listing Page
          </SrText>
        </SrBox>
        <SrLinkUrlButton
          className='blueTheme'
          href={[
            appUrl,
            `/listing/${listingId}?`,
            [
              'utm_source=sunroom',
              'utm_medium=textlink',
              'utm_campaign=share-this-page',
              'utm_content=copy-link',
            ].join('&'),
          ].join('')}
        />
      </SrBox>
    </SrBox>
  </SrModalV2>
);

SrPartnerShareListingModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  appUrl: PropTypes.string.isRequired,
  listingId: PropTypes.number.isRequired,
  location: PropTypes.object.isRequired,
};

SrPartnerShareListingModal.displayName = 'SrPartnerShareListingModal';

export default SrPartnerShareListingModal;
